import styled from 'styled-components'

export const FormWrapper = styled.div`
  padding: 10px;
  width: 60%;
  @media (max-width: 1700px) {
    width: 70%;
  }
  @media (max-width: 800px) {
    width: 80%;
  }
  @media (max-width: 666px) {
    width: 90%;
  }
  .title {
    margin-left: 10px;
    font-weight: 550;
  }
  .form {
    margin-top: 20px;
  }
  .checked_box {
    display: flex;
    justify-content: space-between;
    user-select: none;
  }
  .third_party_logos {
    display: flex;
    justify-content: center;
    span {
      margin: 0 15px;
      cursor: pointer;
    }
  }
  .login-form-button {
    width: 100%;
    height: 38px;
  }

  .android-button {
    margin-left: 10px;
    margin-right: 10px;
    width: 100%;
    height: 38px;
    background-color: #5958c6;
  }

  .iOS-button {
    margin-left: 10px;
    margin-right: 10px;
    width: 100%;
    height: 38px;
    background-color: #333333;
  }

  .about-button {
    margin-left: 10px;
    margin-right: 10px;
    width: 100%;
    height: 38px;
    background-color: #f4f4f4;
    color: #333333;
  }

  .tutorial-button {
    margin-left: 10px;
    margin-right: 10px;
    width: 100%;
    height: 38px;
    background-color: #8E61F1;
    color: #fff;
  }

   .group-button {
    margin-left: 10px;
    margin-right: 10px;
    width: 100%;
    height: 38px;
    background-color: #C6B0F8;
    color: #fff;
  }

  .wx-button {
    margin-left: 10px;
    margin-right: 10px;
    width: 100%;
    height: 38px;
    background-color: #FA876B;
    color: #fff;
  }

  .left {
    margin: 10px;
  }

  .form {
    margin-left: 0px;
    margin-right: 20px;
  }

  .image {
    width: 130px;
    height: 130px;
  }

  .img {
    border-radius: 15px;
  }

  .bottom {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .tip {

  }

  .tips {
    color: #999999;
  }
`
